const LibString = () => {
	function capitalizeFirstLetter(str) {
		try {
			str = str.toLowerCase();

			return str.charAt(0).toUpperCase() + str.slice(1);
		} catch (error) {
			return "";
		}
	}

	return {
		capitalizeFirstLetter,
	};
};

function removeSpaces(text) {
	// ex: empresa fulano de tal
	//     empresafulanodetal
	return text.replace(/\s+/g, "");
}

function onlyNumbers(text) {
	return text.replace(/\D/g, "");
}

function splitText(text, separator) {
	const index = text.indexOf(separator);

	if (index === -1) {
		return [text, ""];
	}

	return [text.slice(0, index), text.slice(index + 1)];
}

function strtoInt(valueStr) {
	try {
		return parseInt(valueStr);
	} catch (error) {
		return 0;
	}
}

export { LibString, removeSpaces, onlyNumbers, splitText, strtoInt };
